<template>
  <component :is="tag" v-bind="linkProps" class="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100" @click="handleClick">
    <slot />
  </component>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'
import { RouterLink } from 'vue-router'

export default defineComponent({
  name: 'TwDropdownItem',
  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const closeDropdown = inject('closeDropdown')

    const tag = computed(() => {
      if (props.to) return RouterLink
      if (props.href) return 'a'
      return 'button'
    })

    const linkProps = computed(() => {
      if (props.to) {
        return { to: props.to }
      } else if (props.href) {
        return {
          href: props.href,
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      } else {
        return { type: 'button' }
      }
    })

    const handleClick = () => {
      if (closeDropdown) closeDropdown()
    }

    return {
      tag,
      linkProps,
      handleClick,
    }
  },
})
</script>
